import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { GridPagination } from "@mui/x-data-grid-pro";
import { isEqual } from "lodash";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import AssetAnalyzeFilters from "./AssetAnalyzeFilters";
import AssetStatusBuildColumns from "../assetStatus/Table/columns";
import buildColumns from "../assetHistory/Table/columns";
import MaterialUiDataGridPremium from "../../../components/Tables/DataGridPremium/MaterialUiDataGridPremium";
import moment from "moment";

export default function AssetAnalysis(props) {
  const {
    apiUrl,
    handleSave,
    // The things this boolean does is determine what filters are appended, what endpoint we hit, and the id to be used for the row.
    // Everything else is the same
    isAssetAnalysis = false,
    organizationId,
    timeZone,
    token,
    userId,
    useSelector = () => { },
  } = props;
  const [state, setState] = useState({
    filters: {
      assetCategories: [],
      binLocations: [],
      classifications: [],
      customs: [],
      endDate: new Date(),
      events: [],
      limit: 10000,
      // Start date will default to todays date
      startDate: new Date(),
      tag: "",
      users: [],
    },
    assetHistories: [],
    realCount: false,
  });

  const { realCount } = state;

  // OK to destructure, as no changes to org data takes place in this page
  const { zones, facilities, customs, classifications } =
    useSelector((state) => state.organization, isEqual) || {};

  const displayConfigs =
    useSelector((state) => state.organization.displayConfig) || [];
  const history = useHistory();
  const specificConfig = isAssetAnalysis
    ? displayConfigs.find((element) => element.type === "AssetItemAnalysis")
    : displayConfigs.find((element) => element.type === "AssetEventAnalysis");
  const columnOrder = specificConfig?.columns || null;

  const assetClassifications = Object.values(classifications).filter(classification => classification.assetMode === "Asset")
  const assetCustoms = customs.filter(custom => custom.assetMode === "Asset")

  const { historyTableColumns: assetEventAnalysisColumns } = buildColumns({
    apiUrl,
    classifications: assetClassifications,
    columnOrder,
    customs: assetCustoms,
    facilities,
    handleSave,
    history,
    setState,
    timeZone,
    token,
    userId,
    zones,
  });

  const { historyTableColumns: assetItemAnalysisColumns } =
    AssetStatusBuildColumns({
      apiUrl,
      classifications: assetClassifications,
      columnOrder,
      customs: assetCustoms,
      facilities,
      handleSave,
      history,
      setState,
      timeZone,
      token,
      userId,
      zones,
    });

  const currentTime = moment().tz(timeZone).format("YYYY-MM-DD");
  const exportFileName = isAssetAnalysis ? `Asset-Analysis_${currentTime}` : `Event-Analysis_${currentTime}`;

  function CustomPagination() {
    return (<Typography component="div"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px"
      }}
    >
      {realCount && realCount > 10000 ? <Typography component="p" sx={{ fontSize: "0.875rem" }} >Real Count: {realCount}</Typography> : <p>{" "}</p>}
      <GridPagination />
    </Typography>
    )
  }
  return (
    (<Grid
      container
      className="asset-analyze"
      style={{
        marginTop: "1rem",
        margin: "0 auto",
        width: "84vw",
      }}
    >
      {/* Filters  */}
      <Grid size={12}>
        <AssetAnalyzeFilters
          apiUrl={apiUrl}
          isAssetAnalysis={isAssetAnalysis}
          setState={setState}
          state={state}
          organizationId={organizationId}
          token={token}
        />
      </Grid>
      {/* Table */}
      <Grid sx={{ margin: "1rem 0 !important" }} size={12}>
        <MaterialUiDataGridPremium
          autoHeight={false}
          checkboxSelection={false}
          columns={isAssetAnalysis ? assetItemAnalysisColumns : assetEventAnalysisColumns}
          customComponents={{
            Footer: CustomPagination,
          }}
          delayedLoad={false}
          disableAggregation={false}
          disableCsvExportOption={false}
          exportFileName={exportFileName}
          getRowId={(row) => isAssetAnalysis ? row.assetId : row.assetHistoryId}
          loading={false}
          rows={state?.assetHistories}
        />
      </Grid>
    </Grid>)
  );
}
